import { useState, useEffect } from 'react';
import { 
  Box, 
  Heading, 
  Text, 
  Breadcrumb, 
  BreadcrumbItem, 
  BreadcrumbLink,
  Container,
  Alert,
  AlertIcon,
  AlertTitle,
  AlertDescription,
  useToast
} from '@chakra-ui/react';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import { ChevronRightIcon } from '@chakra-ui/icons';
import TicketForm from '../../components/tickets/TicketForm';
import { useAuth } from '../../contexts/AuthContext';

const NewTicket = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const toast = useToast();
  const [unauthorized, setUnauthorized] = useState(false);

  // Prevent support users from accessing the new ticket page
  useEffect(() => {
    if (user?.role === 'support') {
      setUnauthorized(true);
      toast({
        title: 'Access Denied',
        description: 'Support users cannot create tickets.',
        status: 'error',
        duration: 5000,
        isClosable: true,
      });
      // Redirect after 3 seconds
      const timer = setTimeout(() => {
        navigate('/tickets');
      }, 3000);
      
      return () => clearTimeout(timer);
    }
  }, [user, navigate, toast]);

  if (unauthorized) {
    return (
      <Alert
        status="error"
        variant="subtle"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        textAlign="center"
        height="200px"
      >
        <AlertIcon boxSize="40px" mr={0} />
        <AlertTitle mt={4} mb={1} fontSize="lg">
          Access Denied
        </AlertTitle>
        <AlertDescription maxWidth="sm">
          Support users cannot create tickets. Redirecting to tickets list...
        </AlertDescription>
      </Alert>
    );
  }

  return (
    <Box>
      <Breadcrumb 
        spacing="8px" 
        separator={<ChevronRightIcon color="gray.500" />}
        mb={6}
      >
        <BreadcrumbItem>
          <BreadcrumbLink as={RouterLink} to="/dashboard">Dashboard</BreadcrumbLink>
        </BreadcrumbItem>
        <BreadcrumbItem>
          <BreadcrumbLink as={RouterLink} to="/tickets">Tickets</BreadcrumbLink>
        </BreadcrumbItem>
        <BreadcrumbItem isCurrentPage>
          <BreadcrumbLink>New Ticket</BreadcrumbLink>
        </BreadcrumbItem>
      </Breadcrumb>

      <Heading size="lg" mb={2}>Submit a New Ticket</Heading>
      <Text color="gray.600" mb={6}>
        Fill out the form below to create a new support ticket.
      </Text>

      <Container maxW="container.md" p={0}>
        <TicketForm />
      </Container>
    </Box>
  );
};

export default NewTicket;
